import React from 'react';
import styled from '@emotion/styled';
import { Card } from '@sunrun/component-library';
import { MAX_DESKTOP_BREAKPOINT, MIN_DESKTOP_BREAKPOINT } from './constants/_breakpoints';
import { BRAND_MEDIUM_BLUE, PRODUCT_CARD_DARK_BLUE, WHITE_COLOR } from './constants/_colors';
const CARD_HEADER_HEIGHT = 44;
const ASSET_OFFSET_TOP = `-${CARD_HEADER_HEIGHT}px`;
const ASSET_WIDTH_SPACING = '150px + 1rem';
const StyledCard = styled(Card) `
  display: flex;
  flex-direction: column;
  padding: 0 !important;
  margin-bottom: 15px;
  overflow: hidden;
  min-height: 166px;
`;
const StyledCardHeader = styled.div `
  align-content: center;
  background: ${PRODUCT_CARD_DARK_BLUE};
  color: ${WHITE_COLOR};
  font-weight: 750;
  min-height: ${CARD_HEADER_HEIGHT}px;
  padding: 0.75rem calc(${ASSET_WIDTH_SPACING}) 0.75rem 20px;
  font-family: Roobert;
  font-size: 16px;

  @media only screen and (max-width: ${MIN_DESKTOP_BREAKPOINT}) {
    padding-right: 0;
  }
`;
const StyledCardBody = styled.div `
  display: flex;
  height: 122px;
  justify-content: space-between;
  padding: 0.5rem;
  position: relative;
`;
const TextContainer = styled.div `
  margin-right: 10px;
  padding: 10px 20px;

  font-family: Roobert;
  font-size: 14px;
  font-weight: 400;

  a {
    color: ${BRAND_MEDIUM_BLUE};
    text-decoration: underline;
  }
`;
const AssetContainer = styled.div `
  position: relative;
  top: ${ASSET_OFFSET_TOP};

  @media only screen and (max-width: ${MAX_DESKTOP_BREAKPOINT}) {
    display: none;
  }
`;
const ProductCard = ({ headerText, bodyText, imageAsset }) => {
    return (React.createElement(StyledCard, null,
        React.createElement(StyledCardHeader, null, headerText),
        React.createElement(StyledCardBody, null,
            React.createElement(TextContainer, null, bodyText),
            React.createElement(AssetContainer, null, imageAsset))));
};
export default ProductCard;
